import React, { useState, useEffect } from 'react';
import api from '../services/api';
import { IconePlume } from './IconesSVG';

const dateFr = (d) => (d ? new Date(d).toLocaleDateString('fr-FR') : '');

// Bandeau affiche dans le parapheur quand le signataire agit par delegation.
// Signer au nom d'un autre engage : mieux vaut le rappeler a l'ecran plutot que
// de le laisser decouvrir sur le PDF genere.
export default function BandeauDelegation() {
  const [delegation, setDelegation] = useState(null);

  useEffect(() => {
    let vivant = true;
    api.get('/delegations/active')
      .then((res) => { if (vivant) setDelegation(res.data || null); })
      .catch(() => { /* l'absence de delegation n'est pas une erreur */ });
    return () => { vivant = false; };
  }, []);

  if (!delegation?.delegant) return null;

  const { delegant, date_fin: dateFin, montant_max: montantMax } = delegation;

  return (
    <div style={s.bandeau}>
      <span style={s.icone}><IconePlume taille={16} /></span>
      <div style={{ minWidth: 0 }}>
        <div style={s.titre}>
          Vous signez par délégation de {delegant.prenom} {delegant.nom}
        </div>
        <div style={s.detail}>
          Délégation active jusqu&apos;au {dateFr(dateFin)}
          {montantMax
            ? ` · plafond ${Number(montantMax).toLocaleString('fr-FR')} FCFA`
            : ''}
        </div>
      </div>
    </div>
  );
}

const s = {
  bandeau: {
    display: 'flex', alignItems: 'center', gap: 10,
    background: '#FEF9E7', border: '1px solid #9A7D0A', borderRadius: 10,
    padding: '10px 14px', margin: '0 0 12px', fontFamily: 'inherit',
  },
  icone: { color: '#9A7D0A', display: 'inline-flex', flexShrink: 0 },
  titre: { fontSize: 13, fontWeight: 700, color: '#7D6608' },
  detail: { fontSize: 12, color: '#9A7D0A', marginTop: 2 },
};
